import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  update() {
    const tags = this.inputTarget.value.split(",").map(tag => tag.trim()).filter(tag => tag);
    this.inputTarget.value = tags.join(", ");
  }
}
